import React, {useEffect, useState} from "react";
import {companyService} from "../../../services";
import {Modal, notification, Table} from "antd";
import Spinner from "../../spinner";
import i18n from "../../../i18n";
import {approveAction, getTranslatedConstant} from "../../../helpers/translate.helpers";

export default function ModalApproveOrderHistoryList({id, isShow, setIsShow}) {
  const [listApproveOrderHistory, setListApproveOrderHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id && isShow) {
      setLoading(true);
      companyService.getApproveOrderHistory(id)
        .then(resp => {
          setListApproveOrderHistory(resp);
          setLoading(false);
        })
        .catch((err) => {
          notification.error({
            message: i18n.t('components.notification.titles.getApproveOrderHistory'),
            description: err,
          });
        });
    }
  }, [id, isShow])

  const approveActionList = getTranslatedConstant('approveAction');

  const columns = [
    {
      title: i18n.t('modals.modalApproveOrderHistoryList.table.status.title'),
      render: (record) => {
        return <>
          <b>{record.action}</b>
          {record.user.name}
          {record.date}
        </>
      },
      className: "desktop-hidden"
    },
    {
      title: i18n.t('modals.modalApproveOrderHistoryList.table.status.title'),
      className: "mobile-hidden",
      render: (record) => {
        const action = Object.entries(approveAction).filter((item) => {
            return item[1] === record.action || record.action.includes(item[1]);
          }
        )
        if(action.length > 0) {
          if(action[0][1] !== record.action) {
            return <>{approveActionList[action[0][0]]} {record.action.split(action[0][1])[1]}</>
          } else {
            return <>{approveActionList[action[0][0]]}</>
          }
        } else {
          return record.action;
        }
      }
    },
    {
      title: i18n.t('modals.modalApproveOrderHistoryList.table.name.title'),
      render: (record) => (
        <React.Fragment>
          {record.user.name}
        </React.Fragment>
      ),
      key: 'user.id',
      className: "mobile-hidden"
    },
    {
      title: i18n.t('modals.modalApproveOrderHistoryList.table.date.title'),
      dataIndex: 'date',
      key: 'date',
      className: "mobile-hidden"
    },
  ];


  return (
    <Modal
      title={i18n.t('modals.modalApproveOrderHistoryList.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      onOk={() => {
        setIsShow(false);
      }}
    >
      <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
        <Table
          columns={columns}
          dataSource={listApproveOrderHistory}
          bordered={true}
          locale={{emptyText: i18n.t('main.empty')}}
          className={"employees-table"}
          rowKey={"id"}
        />
      </Spinner>
    </Modal>
  );
}
